import { render, staticRenderFns } from "./businessProcessOutsourcing.vue?vue&type=template&id=93e81aa2&lang=html&"
import script from "./businessProcessOutsourcing.vue?vue&type=script&lang=js&"
export * from "./businessProcessOutsourcing.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "businessProcessOutsourcing.vue"
export default component.exports